import {
  Provider,
  QueryAndOutputs,
  WorkflowCodeType,
  WorkflowComponentCodeParams,
  WorkflowComponentOutputTablesParams,
  WorkflowComponentOutputType,
  WorkflowComponentParamType
} from '../types'
import { WorkflowComponent } from './common/workflowcomponent'

class ReadTable extends WorkflowComponent {
  constructor() {
    super(
      {
        name: 'ReadTable',
        group: '__internal',
        title: 'Read Table',
        description: ''
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.String,
          title: 'Source table fqn'
        }
      ],
      [
        {
          name: 'out',
          title: 'Table',
          description: 'The output table',
          type: WorkflowComponentOutputType.Table
        }
      ]
    )
    this.hidden = true
  }

  async getFullCodeSnippet(params: WorkflowComponentCodeParams): Promise<QueryAndOutputs | null> {
    if (params.codeType === WorkflowCodeType.DryRun) {
      return await super.getFullCodeSnippet(params)
    } else {
      return {
        query: '',
        outputs: {
          out: params.params.source as string
        }
      }
    }
  }

  async getCode({
    workflow,
    params,
    connection,
    componentName,
    codeType
  }: WorkflowComponentCodeParams): Promise<QueryAndOutputs> {
    if (codeType === WorkflowCodeType.DryRun) {
      const tablename = connection.getOutputTableName(workflow.id, componentName, params, 'out', codeType)
      const query = connection.getCreateTempTableQuery(
        tablename,
        `SELECT * FROM ${connection.quoteName(params.source as string)}`,
        codeType,
        null
      )
      return {
        query,
        outputs: { out: tablename }
      }
    } else {
      return {
        query: '',
        outputs: { out: params.source as string }
      }
    }
  }

  getOutputTables({
    workflow,
    params,
    connection,
    componentName,
    codeType
  }: WorkflowComponentOutputTablesParams): Record<string, string> {
    if (codeType === WorkflowCodeType.DryRun) {
      const tablename = connection.getOutputTableName(workflow.id, componentName, params, 'out', codeType)
      return { out: tablename }
    } else {
      return { out: params.source as string }
    }
  }

  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { ReadTable }
